import { Alert as AntAlert, AlertProps as AntAlertProps } from 'antd'

import './AlertStylesOverrides.less'

type AlertProps = AntAlertProps & {
  alignItems?: 'top' | 'center'
}
function Alert(props: AlertProps) {
  return <AntAlert className={props.alignItems === 'top' ? 'icon-top' : 'icon-center '} {...props} />
}

export default Alert
